var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(! _vm.userSession.isUserSignedIn())?_c('landing'):_vm._e(),(_vm.user)?_c('dashboard',{attrs:{"user":_vm.user}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }